/**
@ngdoc directive
@name calcSumDurationRow

@description
Calculate Sum of time/duration properties, albeit subtraction or addition


	// Object with all the properties you wish to subtract or add too.
	calc-sum-duration-row="formModel.timeRecordHourlyList[0]"

	// (Optional) Property key or keys of which we collect duration value or duration values to ADD
		// Singular standard duration object
	calc-sum-duration-row-add="hour:minute"
		// Mutiple standard duration objects
	calc-sum-duration-row-add="hour1:minute1,hour2:minute2"

	// (Optional) Property key or keys of which we collect duration value or duration values to ADD
		// Singular time duration object
	calc-sum-duration-row-add-time="start:end"
		// Mutiple time duration objects
	calc-sum-duration-row-add-time="start1:end1,start2:end2"

	// (Optional) Property key or keys of which we collect duration value or duration values to SUBTRACT
		// Singular standard duration object
	calc-sum-duration-row-subtract="hour:minute"
		// Mutiple standard duration objects
	calc-sum-duration-row-subtract="hour1:minute1,hour2:minute2"

	// (Optional) Property key or keys of which we collect duration value or duration values to SUBTRACT
		// Singular time duration object
	calc-sum-duration-row-subtract-time="start:end"
		// Mutiple time duration objects
	calc-sum-duration-row-subtract-time="start1:end1,start2:end2"

	//Property key where to output resultant
	calc-sum-duration-row-result="hourResult:minuteResult"

@usage
	http://localhost:8080/testSearch/angularSums
	<!-- Used in Hourly timesheets -->
	<span calc-sum-duration-row="formModel.timeRecordHourlyList[${i}]"
		calc-sum-duration-row-add-time="startTime:endTime"
		calc-sum-duration-row-subtract="unpaidBreaksHours:unpaidBreaksMinutes"
		calc-sum-duration-row-result="claimedHours:claimedMinutes"></span>

	<!-- Complex example -->
	<span calc-sum-duration-row="formModel.timeList[${i}]"
		calc-sum-duration-row-add="hour1:minute1,hour3:minute3"
		calc-sum-duration-row-add-time="start1:end1,start3:end3"
		calc-sum-duration-row-subtract="hour2:minute2,hour4:minute4"
		calc-sum-duration-row-subtract-time="start2:end2,start4:end4"
		calc-sum-duration-row-result="totalHour:totalMinute"></span>
	<!-- The above would do the following complex sum
		var duration = formModel.timeList[${i}].hour1 + formModel.timeList[${i}].minute1
					 + formModel.timeList[${i}].hour3 + formModel.timeList[${i}].minute3
					 + (formModel.timeList[${i}].end1 - formModel.timeList[${i}].start1)
					 + (formModel.timeList[${i}].end3 - formModel.timeList[${i}].start3)
					 - formModel.timeList[${i}].hour2 + formModel.timeList[${i}].minute2
					 - formModel.timeList[${i}].hour4 + formModel.timeList[${i}].minute4
					 - (formModel.timeList[${i}].end2 - formModel.timeList[${i}].start2)
					 - (formModel.timeList[${i}].end4 - formModel.timeList[${i}].start4);
		formModel.timeList[${i}].totalHour = duration.hour;
		formModel.timeList[${i}].totalMinute = duration.minute;
	 -->

*/
(function() {
	'use strict';

	var calcSumDurationRow = function(durationService) {
		return {
			restrict: "A",
			scope: true,
			bindToController: {
			   rowObject: "=calcSumDurationRow",
			   addPropList: "@calcSumDurationRowAdd", //may be a list or a single property
			   subtractPropList: "@calcSumDurationRowSubtract", //may be a list or a single property
			   addTimePropList: "@calcSumDurationRowAddTime", //may be a list or a single property
			   subtractTimePropList: "@calcSumDurationRowSubtractTime", //may be a list or a single property
			   result: "@calcSumDurationRowResult"
			},
			controllerAs: 'ctrl',
			controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
				var DEBUG = false;
				var _this = this;

				var hourMinuteRef,
					propertyKeyListRef,
					keys;


				_this.$onInit = function(){

					if(DEBUG) {
						console.log('calcSumDurationRow() running...', _this.rowObject);
					}

					//Function References
					hourMinuteRef =  durationService.hourMinute;
					propertyKeyListRef = hourMinuteRef.propertyKeyList;

					if( !angular.isDefined(_this.result) ){
						throw 'Exception (calcSumDurationRow.js): Undeclared directive attribute calc-sum-duration-row-result';
					}
					// Define & create Property Keys
					keys = {
						result:  hourMinuteRef.propertyKey.createDuration( _this.result ),
						duration: {
							add: angular.isDefined(_this.addPropList) 			? propertyKeyListRef.createDuration( _this.addPropList ) : null,
							subtract: angular.isDefined(_this.subtractPropList) ? propertyKeyListRef.createDuration( _this.subtractPropList ) : null
						},
						time: {
							add: angular.isDefined(_this.addTimePropList) 			? propertyKeyListRef.createTime( _this.addTimePropList ) : null,
							subtract: angular.isDefined(_this.subtractTimePropList) ? propertyKeyListRef.createTime( _this.subtractTimePropList ) : null
						}
					};

					if(DEBUG) {
						console.log('keys: ',keys);
					}
				}


				//watch for changes in row
				$scope.$watch(
					function(){
						return (_this.rowObject);
					},
					function(newObject, oldObject){
						if(newObject!=oldObject) { //handle changes in row
							if(DEBUG) console.log('calcSumDurationRow() change occurred',newObject);

							var duration = hourMinuteRef.duration(0,0);

							angular.forEach(keys.time.add, function(propertyKeys){
								duration = hourMinuteRef.addDifferenceBetween( duration, newObject[propertyKeys.start], newObject[propertyKeys.end] );
							});

							angular.forEach(keys.duration.add, function(propertyKeys){
								duration = hourMinuteRef.add( duration, newObject[propertyKeys.hour],   durationService.HOUR );
								duration = hourMinuteRef.add( duration, newObject[propertyKeys.minute], durationService.MINUTE );
							});

							angular.forEach(keys.time.subtract, function(propertyKeys){
								duration = hourMinuteRef.subtractDifferenceBetween( duration, newObject[propertyKeys.start], newObject[propertyKeys.end] );
							});

							angular.forEach(keys.duration.subtract, function(propertyKeys){
								duration = hourMinuteRef.subtract( duration, newObject[propertyKeys.hour],   durationService.HOUR );
								duration = hourMinuteRef.subtract( duration, newObject[propertyKeys.minute], durationService.MINUTE );
							});

							if(DEBUG) console.log(duration);
							//Update result properties
							newObject[keys.result.hour] = duration.hour;
							newObject[keys.result.minute] = duration.minute;
						}
					},
					true
				);
			}],
			replace: false,
			transclude: false
		};
	}
	calcSumDurationRow.$inject = ['durationService'];
	angular.module('app').directive('calcSumDurationRow', calcSumDurationRow);

}());
